import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { EvidencePlatformSidebarAppID } from '@verantos-dev/core-enums';

interface AppState {
  id: EvidencePlatformSidebarAppID | undefined;
}

const initialState: AppState = { id: undefined };

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setAppId: (state, action: PayloadAction<EvidencePlatformSidebarAppID>) => {
      state.id = action.payload;
    },
  },
});

export const { setAppId } = appSlice.actions;
export default appSlice.reducer;
